import JSZip from 'jszip';
import { ResourcePackage } from './ResourcePackage';
import { ZipResourceCache } from './ZipResourceCache';

export class FileResourceCache extends ZipResourceCache {
  async loadPackageFile(zipFile: File): Promise<ResourcePackage> {
    try {
      const data = zipFile.arrayBuffer();
      const zip = await JSZip.loadAsync(data);
      const file = Object.values(zip.files)[0];

      if (!file) {
        throw new Error(`${zipFile.name} there is no file in zip`);
      }

      const xml = await file.async('string');
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(xml, 'text/xml');
      if (xmlDoc.firstChild) {
        return await this._loadPackage(xmlDoc.firstChild as Element);
      } else {
        throw new Error(`${zipFile.name} there is not loading`);
      }
    } catch (error) {
      throw error;
    }
  }
}
